module.exports = __webpack_public_path__ + "img/Rectangle 15237.07c31c0f.svg";